import Socket from '../../classes/WebSocket'
import VueSignals from '../../scripts/VueSignals';


export default class ChannelNotification{
    constructor(){}
    /**
     *  Notification  Channel Invitation channel by Invitation acception
     */
    static ChannelInviteUser(channel_doc, creator_user_id, invitation_id, invitee_id){
        let invitaion_post = {
            "event": VueSignals.SOCKET_CHANNEL_INVITE,
            "channel_name": channel_doc.channel_name,
            "channel_id": channel_doc.channel_id,
            "channel_purpose": channel_doc.channel_purpose,
            "invitation_id": invitation_id, 
            "publish_user_cp_id": creator_user_id,   
            "broadcast": {
                "user_ids": invitee_id,
            }
        }
        Socket.push(invitaion_post)
    }


    static CreateChannel(channel_doc, creator_user_id){
        let channel_post = {
            "event": VueSignals.SOCKET_CHANNEL_CREATE,
            "channel_doc": channel_doc,             
            "publish_user_cp_id": creator_user_id,   
            "broadcast": {
                "user_ids": [creator_user_id],
            }
        }
        Socket.push(channel_post)
    }


    

    static RemoveChannelInvite(invitation_id ,user_ids, channel_id, removed_user_id){                        
        let remove_invitaion_post = {
            "event": VueSignals.SOCKET_CHANNEL_REMOVE_INVITATION,            
            "invitation_id": invitation_id, 
            "channel_id": channel_id, 
            "removed_user_id":removed_user_id,
            "broadcast": {
                "user_ids": user_ids,
            }
        }  

        Socket.push(remove_invitaion_post)
    }

    static PostEdited(post_id,channel_id,post_data,user_ids){
        let post = {
            "event": VueSignals.SOCKET_POST_EDITED,
            "post_id": post_id,
            "channel_id": channel_id,
            "post": post_data,
            "broadcast": {
                "user_ids": user_ids
            },
        }
        Socket.push(post);
    }

    static PostDeleted(post_id,channel_id,user_ids){
        let post = {
            "event": VueSignals.SOCKET_POST_DELETED,
            "post_id": post_id,
            "channel_id": channel_id,
            "broadcast": {
                "user_ids": user_ids
            },
        }
        Socket.push(post);
    }

    static Typying(channel_id,user_ids){
        let post = {
            "event": VueSignals.TYPING_ACTION_NOTIFICATION,
            "channel_id": channel_id,
            "broadcast": {
                "user_ids": user_ids
            },
        }
        Socket.push(post);
    }


    static ChannelPurposeEdit(channel_id, purpose, user_ids){
        let post = {
            "event": VueSignals.SOCKET_CHANNEL_PURPOSE_EDIT,
            "channel_id": channel_id,
            "channel_purpose": purpose,
            "broadcast": {
                "user_ids": user_ids
            },
        }
        Socket.push(post);
    }

    static ChannelDelete(channel_id, user_ids){
        let post = {
            "event": VueSignals.SOCKET_CHANNEL_DELETED,
            "channel_id": channel_id,
            "broadcast": {
                "user_ids": user_ids
            },
        }
        Socket.push(post);
    }

    static RemoveUser(user_object ,channel_id, user_ids){                        
        let remove_user = {
            "event": VueSignals.SOCKET_REMOVE_USER_FROM_CHANNEL,            
            "channel_id": channel_id,             
            "broadcast": {
                "user_ids": user_ids,
            }
        }

        if(typeof user_object.user_id != 'undefined' && user_object.user_id.length > 0){
            remove_user.removed_user_id = user_object.user_id
        }else {
            remove_user.removed_email = user_object.email
        }   

        Socket.push(remove_user)
    }


    static RemoveLicense(channel_id, removed_license_id , user_ids){                        
        let remove_license = {
            "event": VueSignals.REMOVE_CHANNEL_LICENSE,            
            "channel_id": channel_id, 
            "removed_license_id":removed_license_id,
            "broadcast": {
                "user_ids": user_ids,
            }
        }  
        Socket.push(remove_license)
    }

    static AssignLicense(channel_id, assigned_license , user_ids){                        
        let add_license = {
            "event": VueSignals.ADD_CHANNEL_LICENSE,            
            "channel_id": channel_id, 
            "assigned_license":assigned_license,
            "broadcast": {
                "user_ids": user_ids,
            }
        }  
        Socket.push(add_license)
    }
}
